import { useRef } from 'react';

// Debounced function that can be cleared manually
export const useClearableDebounce = (
  timeLimitMs = 5000,
): { clearDebounce: () => void; debouncedFn: (func: () => void) => void } => {
  const timer = useRef(null);

  return {
    clearDebounce: () => {
      if (timer?.current) clearTimeout(timer.current);
    },
    debouncedFn: (func: () => void) => {
      if (timer?.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        func?.();
      }, timeLimitMs);
    },
  };
};
